import { render, staticRenderFns } from "./OrderDistributionPrint.vue?vue&type=template&id=7c773c3f&"
import script from "./OrderDistributionPrint.vue?vue&type=script&lang=js&"
export * from "./OrderDistributionPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
